// extracted by mini-css-extract-plugin
module.exports = {"content":"OverviewCard_content__R1WSs"};